import { createTheme } from '@mui/material/styles'
import palette from './palette'
import typography from './typography'
import components from './components'

const theme = createTheme({
  palette,
  typography,
  components,
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
})

export default theme
